const modal = document.getElementById("search-modal");
const input = document.querySelector("[data-predictive-search]");
const results = document.getElementById("search-results");

function openSearch() {
  if (!modal) return;
  modal.hidden = false;
  input?.focus();
}

function closeSearch() {
  if (!modal) return;
  modal.hidden = true;
}

async function predictive(query) {
  if (!results) return;
  const q = query.trim();
  if (!q) {
    results.innerHTML = "";
    return;
  }
  const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`;
  const res = await fetch(url);
  if (!res.ok) return;
  const data = await res.json();
  const products = data.resources?.results?.products || [];
  if (!products.length) {
    results.innerHTML = `<p class="search-empty">No matches for “${q}”. Try smoothie, tea, creatine, or meal prep.</p>`;
    return;
  }
  results.innerHTML = products.map((p) => `
    <a class="search-hit" href="${p.url}">
      <span><strong>${p.title}</strong></span>
      <span class="price">${p.price}</span>
    </a>
  `).join("");
}

document.querySelectorAll("[data-open-search]").forEach((el) => {
  el.addEventListener("click", openSearch);
});
modal?.addEventListener("click", (e) => {
  if (e.target === modal) closeSearch();
});
input?.addEventListener("input", (e) => {
  predictive(e.target.value);
});
document.addEventListener("keydown", (e) => {
  if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
    e.preventDefault();
    openSearch();
  }
  if (e.key === "Escape") closeSearch();
});
